// src/utils/buyerLeadStages.js
// Pure, Firebase-free: the buyer pipeline's stages, colors, and label maps.

// The auto-intake column for open-house sign-ins. Kept as a named constant so
// the trigger side (functions-drive/openHouseMapping.js) and the pipeline stay
// in lockstep on the exact string.
export const OPEN_HOUSE_LEADS_STAGE = "Open House Leads";

export const BUYER_STAGE_ORDER = [
  // Auto-intake column (Henry, 2026-09-06): open-house kiosk sign-ins land
  // here automatically for the hosting agent, who works them and moves them
  // into New Lead / Nurturing once contact is made. A starting column, not a
  // parked one, so "advance" from here goes to New Lead.
  OPEN_HOUSE_LEADS_STAGE,
  "New Lead",
  "Nurturing",
  "Consultation",
  "Pre-Approved",
  "Actively Showing",
  "Offer Submitted",
  // Parked stages (Henry, 2026-07-29): not-now buyers rest here without
  // nagging — the pipelines treat these as parkingStages.
  "On Hold",
  "One Day",
];

// The stages that count as "deliberately waiting" on the Buyer Pipeline.
export const BUYER_PARKING_STAGES = ["On Hold", "One Day"];

// Stages were renamed (Contacted → Nurturing, Offer Out → Offer Submitted).
// Existing lead records may still carry the old string, so normalize on read
// to keep them in the right column without a risky bulk DB rewrite.
const STAGE_ALIASES = {
  Contacted: "Nurturing",
  "Offer Out": "Offer Submitted",
};

export const normalizeStage = (stage) => STAGE_ALIASES[stage] || stage;

export const TIMELINE_LABELS = {
  asap: "Buying ASAP",
  "30": "Buying in ~30 days",
  "60": "Buying in ~60 days",
  "90": "Buying in ~90 days",
  "6mo_plus": "Buying in 6+ months",
};

export const PRE_APPROVAL_LABELS = {
  yes: "Pre-approved",
  in_progress: "Pre-approval in progress",
  no: "Not yet pre-approved",
};

export const PROPERTY_TYPE_OPTIONS = [
  "Single-Family",
  "Condo",
  "Townhouse",
  "Multi-Family",
  "Land",
];

export const FINANCING_OPTIONS = ["Conventional", "FHA", "VA", "Cash"];

const STAGE_COLORS = {
  "Open House Leads": "bg-sky-600",
  "New Lead": "bg-slate-400",
  Nurturing: "bg-blue-400",
  Consultation: "bg-cyan-500",
  "Pre-Approved": "bg-violet-500",
  "Actively Showing": "bg-amber-500",
  "Offer Submitted": "bg-emerald-500",
  "On Hold": "bg-gray-400",
  "One Day": "bg-gray-300",
};

export const getBuyerStageColor = (stage) =>
  STAGE_COLORS[stage] || "bg-slate-300";

export const isActiveLead = (lead) =>
  lead?.status === "active" && !(Number(lead?.deletedAt) > 0);
